// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3PefX","title":"Header_title__30RL3"};